import "core-js/modules/es.array.concat.js";
import React from 'react';
import { BASIC } from 'styles/spacingPresets';
import Card from 'components/Card';
import Box from 'components/Box';
import Flex from 'components/Flex';
import Text from 'components/Text';
import PageTitle from 'components/PageTitle';
import OverflowTooltip from 'components/OverflowTooltip';
import ScrollableNav from 'components/ScrollableNav';
import useUniqueId from 'hooks/useUniqueId';
import { CloseButton } from './CloseButton';
function EditorPageHeader(_ref) {
  var wrapperRef = _ref.wrapperRef,
    title = _ref.title,
    providedTitleId = _ref.titleId,
    titleSuffix = _ref.titleSuffix,
    documentTitle = _ref.documentTitle,
    subtitle = _ref.subtitle,
    preTitleContent = _ref.preTitleContent,
    navigationLabel = _ref.navigationLabel,
    children = _ref.children,
    navMenu = _ref.navMenu,
    cardVariant = _ref.cardVariant,
    onClose = _ref.onClose;
  var uniqueId = useUniqueId();
  var titleId = providedTitleId || uniqueId;
  var suffixedTitle = titleSuffix ? "".concat(title, " ").concat(titleSuffix) : title;
  return /*#__PURE__*/React.createElement(Card, {
    ref: wrapperRef,
    as: "header",
    variant: cardVariant,
    position: "relative",
    pl: BASIC.LARGE,
    pr: "m",
    pt: BASIC.SMALL,
    breakpoints: BASIC.BREAKPOINTS,
    overflow: "visible",
    "aria-labelledby": titleId
  }, /*#__PURE__*/React.createElement(Flex, {
    pb: "xxs",
    align: "top"
  }, /*#__PURE__*/React.createElement(Box, {
    grow: true,
    shrink: true
  }, Boolean(preTitleContent) && /*#__PURE__*/React.createElement(Box, {
    mb: "xs"
  }, preTitleContent), /*#__PURE__*/React.createElement(OverflowTooltip, {
    content: suffixedTitle,
    placement: "bottom-start"
  }, /*#__PURE__*/React.createElement(PageTitle, {
    id: titleId,
    size: "large",
    text: documentTitle || title,
    overflow: "ellipsis"
  }, title, Boolean(titleSuffix) && /*#__PURE__*/React.createElement(React.Fragment, null, ' ', /*#__PURE__*/React.createElement(Text, {
    size: "m",
    bold: false,
    ml: "xxs"
  }, titleSuffix)))), Boolean(subtitle) && /*#__PURE__*/React.createElement(Box, {
    mt: "xs"
  }, subtitle)), /*#__PURE__*/React.createElement(Box, {
    mt: "-xxs",
    mr: "-s"
  }, navMenu, onClose && /*#__PURE__*/React.createElement(CloseButton, {
    onClick: onClose
  }))), /*#__PURE__*/React.createElement(ScrollableNav, {
    navigationLabel: navigationLabel
  }, children));
}
export default EditorPageHeader;
export { default as StickyEditorPageHeaderWrapper } from './StickyEditorPageHeaderWrapper';
export { CloseButton };